.ShippingContainer
    width: 100%
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    display: flex
    flex: 1
    flex-direction: column
    align-items: center
    background: rgb($globalSettingsBackgroundPrimary)
    justify-content: space-between
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    overflow: auto
    box-sizing: border-box

.ShippingContainerInner
    position: relative
    width: 100%
    padding: 0 20px
    display: flex
    flex-direction: column
    flex-shrink: 0
    box-sizing: border-box
    overflow: auto

.ShippingTitle
    font-size: 16px
    font-weight: 700

.ShippingItemContainer
    width: calc(100% + 40px)
    margin: 0 -20px
    padding: 0 20px
    display: flex
    flex-direction: column
    align-items: center
    justify-content: space-between
    font-size: 16px
    box-sizing: border-box
    border-bottom: 1px solid rgb($globalSettingsStrokeTertiary)
    &:hover
        border-bottom: 1px solid rgb($globalSettingsStrokeSecondary)
    .ItemLabelContainer
        height: 50px
        width: 100%
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        cursor: pointer

    .ItemCalculateContainer
        width: 100%
        display: flex
        flex-direction: column
        border-bottom: 0
        font-size: 14px
        & > *
            width: 100%

.ShippingItemContainerError
    border: 1px solid rgb($globalErrorBackground) !important
    &:hover
        border: 1px solid rgb($globalErrorBackground) !important
.Option-Error
    width: calc(100% + 40px)
    border: 1px solid rgb($globalErrorBackground)
    padding: 0 20px
    margin: 0 -20px

.DividerContainer
    width: calc(100% + 40px)
    margin: 0 -20px

.DeliveryTitle
    font-size: 14px
    font-weight: 700

.AddressHintContainer
    position: relative
    width: 100%
    height: 0
    box-sizing: border-box
    .AddressHint
        position: absolute
        top: 10px
        left: 0
        width: 100%
        height: 40px
        border: 1px solid rgb($globalSettingsStrokeSecondary)
        border-radius: $globalButtonRounding
        background: rgb($globalSettingsBackgroundPrimary)
        display: flex
        align-items: center
        padding: 0 10px
        cursor: pointer
        &:hover
            background: rgb($globalSettingsBackgroundTertiary)

@media #{$tablet}
    .ShippingContainerInner
        padding: 0 30px
    .ItemLabelContainer
        height: 40px
        width: 100%
        margin: 0 0 10px
        padding: 0 12px
        font-size: 14px
        border: 1px solid rgb($globalSettingsStrokeSecondary)
        border-radius: $globalButtonRounding
        box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
        &:hover
            border: 1px solid rgb($globalSettingsStrokePrimary)
        &:focus-within
            border: 1px solid rgb($globalSettingsStrokePrimary)
    .DividerContainer
        width: calc(100% + 60px)
        margin: 0 -30px

    .Option-Error
        width: calc(100% + 20px)
        border: 1px solid rgb($globalErrorBackground)
        border-radius: $globalButtonRounding
        padding: 10px 10px 0 10px
        margin: 0 -10px
    .ShippingItemContainerError
        padding-top: 10px
        border-radius: $globalButtonRounding
    .ShippingItemContainer
        border-bottom: none
        margin-bottom: 10px
        &:hover
            border-bottom: none
